export default {
  'ALL': 'All',
  'TOPS': 'Tops',
  'FULL PIECE': 'Full Piece',
  'MID WAIST BOTTOMS': 'Mid Waist Bottoms',
  'HIGH WAIST BOTTOMS': 'High Waist Bottoms',
}
